import { createTheme } from "@material-ui/core"

export const createNCTheme = (mode = "light") =>
  createTheme({
    palette: {
      type: mode,
      primary: {
        BG: mode === "dark" ? "#1a1a2e" : "#F5F4F7",
        dark: "#232323",
        contrastText: "#fff",
        main: "#1EAAC4"
      },
      secondary: {
        main: "#E22134"
      },
      background: {
        default: mode === "dark" ? "#121212" : "#fff",
        paper: mode === "dark" ? "#1e1e1e" : "#fff"
      }
    },
    typography: {
      fontFamily: "DM Sans, Roboto, Helvetica, Arial, sans-serif",
      fontSize: 14,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500
    }
  })

const NCTheme = createNCTheme("light")

export default NCTheme
